module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh"
  }, [_vm._v("Acknowledgements")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I am indebted to a number of people without whom these stories would never have been possible. It is impossible to mention each one here.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Bandana, my wife, is behind every little success that I have as an author. She virtually brought me up as a writer.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Dhruv, my etymologist son, played no little role in listening patiently and intelligently to a number of these stories as they progressed.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I am indebted to Mohammad Saleem for translating one of these stories into Urdu. I am also grateful to him for always being so willing to help.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The students of the Amaranatha Jha Hostel of the University of Allahabad deserve special thanks as it was for them that I wrote plays and discovered, in the process, that I could scribble a few lines of fiction.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("But the one whom I cannot leave out is Caleb Mason of Publerati. It was he who accepted these stories for publication and gave me a kind of reassurance in myself. His comments have meant the world to me.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bc40c2b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/acknowledgements.vue
// module id = 63
// module chunks = 0